// extracted by mini-css-extract-plugin
export default {"root":"DetailsHeader_root__+Kkbf","placeHolderShimmer":"DetailsHeader_placeHolderShimmer__eVqKX"};